export default __webpack_public_path__ + "static/media/avatar-user.251b0894.png";